define('components/decorators/info-box',[
    'jquery'
],function($){
    $.extend(companyInfo.decorators, {
        'info-box': function() {
            /* Associated css classes: "success-box" and "error-box"
            <div class="success-box">
                <div>Text</div>
                <span class="ico ico-close remove-box"></span>
            </div>
            */

            var $this = $(this);
            var removeIcon = $this.find('.remove-box');
            var disableAutoclose = $this.data('info-box-disable-autoclose');

            if ($this.children(':visible').length === 0) {
              return;
            }

            // Remove any existing info messages 6 seconds after page load
            if (disableAutoclose === undefined) {
                setTimeout(function () {
                    $this.fadeOut('slow');
                }, 6000);
            }


            // Clicking to remove the info message
            removeIcon.on("click", function() {
                $this.fadeOut('fast');
            });
        }
    });
});

